const FoodValueAccordion = function(settings) {
	"use strict";

	const _self = this;
	const _settings = {};

	Object.assign(_settings, settings);

	function cacheDom() {
		_settings.$el = document.querySelector(_settings.el);
		_settings.$opener = document.querySelector(_settings.opener);
	}

	function bindEvents() {
		_settings.$opener.addEventListener("click", toggleFoodValueDetails);
	}

	function toggleFoodValueDetails() {
		_settings.$el.classList.toggle(_settings.openedClass);
	}

	function init() {
		cacheDom();
		bindEvents();

		return _self;
	}

	return init();
};

export { FoodValueAccordion };
